// istanbul ignore file
'use client';

import { useRouter } from 'next/navigation';

// istanbul ignore file

// this is the same as in useRouterNav.ts, the only diff is the use
// of useRouter from 'next/navigation' instead of next/router due to router compatibility.
// // TODO: DMD-5737 Leave this as default and remove useRouterNav.ts
export function useRouterNav() {
  const router = useRouter();

  const handleNavigation = (path: string, forceReload: boolean = false) => {
    if (forceReload) {
      window.location.href = path;
      return;
    }

    if (path) {
      router.push(path);
    }
  };

  const handleOffRouteChange = () => {
    console.warn(
      'handleOffRouteChange is not supported in App Router. Use useEffect instead.'
    );
  };

  const handleOnRouteChange = () => {
    console.warn(
      'handleOnRouteChange is not supported in App Router. Use useEffect instead.'
    );
  };

  return {
    handleNavigation,
    handleOffRouteChange,
    handleOnRouteChange
  };
}
